import {
    TextField,
    Filters,
    BlockStack,
    Select as PolarisSelect,
} from '@shopify/polaris';
import { useState, useCallback, useEffect } from 'react';
import React from 'react';
import { DI, DIProps } from '../../../../../Core';
import { allfilterI } from '../../Utilities/Interface';
import { Activity, barcodeExist, filterKeySelect, optionsSKUSelect, status } from '../../Utilities/Constants';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    setallFilters: (data: allfilterI) => void;
    allFiltersNew: allfilterI;
    setAppliedFilters: (data: any) => void
    appliedFilters: any;
    loading: boolean;
}

function VariantGridFilter(props: Props) {
    const { t } = useTranslation();
    const { allFiltersNew, setallFilters, setAppliedFilters, appliedFilters, loading } = props
    const [sku, setSku] = useState<string>('');
    const [queryValue, setQueryValue] = useState('');
    const [filter, setfilter] = useState([]);
    const handleSku = useCallback(() => setSku(''), []);

    const handleselectChange = useCallback(
        (value: any, keyFilter: string, type: any) => {
            props.di.globalState.removeLocalStorage('paginationVariant');
            props.di.globalState.removeLocalStorage('inputpage');
            let tempData = { ...allFiltersNew };

            Object.keys(tempData).forEach((key) => {
                if (key == keyFilter && keyFilter == 'Activity') {
                    tempData[key]['textValue'] = value;
                    tempData[key]['change'] = true;
                    props.di.globalState.set(
                        'filtersVariants',
                        JSON.stringify(tempData),
                        true
                    );
                    setallFilters({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Product Status') {
                    tempData[key]['textValue'] = value;
                    tempData[key]['value'] =
                        value == 'Not Listed'
                            ? 'cif_amazon_multi_not_listed' : value == 'Uploaded' ? 'cif_amazon_multi_uploaded'
                                : 'items.status';
                    tempData[key]['change'] = true;
                    props.di.globalState.set(
                        'filtersVariants',
                        JSON.stringify(tempData),
                        true
                    );
                    setallFilters({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Fulfilment Type') {
                    tempData[key]['textValue'] = value;
                    tempData[key]['value'] =
                        value == 'FBM'
                            ? 'cif_amazon_multi_fulfillment_type'
                            : 'items.fulfillment_type';
                    tempData[key]['change'] = true;
                    props.di.globalState.set(
                        'filtersVariants',
                        JSON.stringify(tempData),
                        true
                    );
                    setallFilters({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Template name') {
                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['value'];
                    tempData[key]['label'] = type.filter((valueFilter: any) => {
                        return valueFilter.value == value;
                    })[0]['label'];
                    tempData[key]['change'] = true;
                    props.di.globalState.set(
                        'filtersVariants',
                        JSON.stringify(tempData),
                        true
                    );
                    setallFilters({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Barcode Exists') {
                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['value'];
                    tempData[key]['label'] = type.filter((valueFilter: any) => {
                        return valueFilter.value == value;
                    })[0]['label'];
                    (tempData[key]['change'] = true),
                        props.di.globalState.set(
                            'filtersVariants',
                            JSON.stringify(tempData),
                            true
                        );
                    setallFilters({ ...tempData });
                } else if (key == keyFilter) {
                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['label'];
                    tempData[key]['change'] = true;
                    props.di.globalState.set(
                        'filtersVariants',
                        JSON.stringify(tempData),
                        true
                    );
                    setallFilters({ ...tempData });
                }
            });
        },
        []
    );

    useEffect(() => {
        let filter: any = [];
        let tempData: any = { ...allFiltersNew };
        Object.keys(tempData).forEach((key) => {
            switch (key) {
                case 'Inventory':
                    filter[0] = {
                        key: 'Inventory',
                        label: t('Inventory'),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={filterKeySelect(t)}
                                    value={tempData[key]?.selectValue}
                                    onChange={(value) => {
                                        tempData[key]['selectValue'] = value;
                                        if (tempData[key]['textValue'] !== '')
                                            props.di.globalState.removeLocalStorage(
                                                'paginationVariant'
                                            );
                                        props.di.globalState.set(
                                            'filtersVariants',
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFilters({ ...tempData });
                                    }}
                                />
                                <TextField
                                    min="0"
                                    placeholder={t("enter value")}
                                    type="number"
                                    labelHidden
                                    autoComplete="off"
                                    label={undefined}
                                    value={allFiltersNew[key]?.textValue}
                                    onChange={(value) => {
                                        tempData[key]['textValue'] =
                                            value.trim() != ''
                                                ? parseInt(value).toFixed()
                                                : 0;
                                        tempData[key]['change'] =
                                            value.trim() != '' ? true : false;
                                        props.di.globalState.removeLocalStorage(
                                            'paginationVariant'
                                        );
                                        props.di.globalState.set(
                                            'filtersVariants',
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFilters({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'SKU':
                    filter[1] = {
                        key: 'SKU',
                        label: t('SKU'),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={optionsSKUSelect(t)}
                                    value={t(tempData[key]['selectValue'])}
                                    onChange={(value) => {

                                        tempData[key]['selectValue'] = value;
                                        if (tempData[key]['textValue'] !== '')
                                            props.di.globalState.removeLocalStorage(
                                                'paginationVariant'
                                            );
                                        props.di.globalState.set(
                                            'filtersVariants',
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFilters({ ...tempData });
                                    }}
                                />
                                <TextField
                                    labelHidden
                                    autoComplete="off"
                                    label={undefined}
                                    placeholder={t("enter value")}
                                    value={tempData[key]['textValue']}
                                    onChange={(value) => {
                                        tempData[key]['textValue'] =
                                            value.trim() != '' ? value : '';
                                        tempData[key]['change'] =
                                            value.trim() != '' ? true : false;
                                        props.di.globalState.removeLocalStorage(
                                            'paginationVariant'
                                        );
                                        props.di.globalState.set(
                                            'filtersVariants',
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFilters({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'Product Status':
                    filter[2] = {
                        key: 'Product Status',
                        label: t('Product status'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={t("Choose...")}
                                value={

                                    status(t).filter((value) => {
                                        return (
                                            value.label ==
                                            allFiltersNew[key].textValue
                                        );
                                    })[0]?.['value']
                                }
                                options={status(t)}
                                onChange={(value) =>
                                    handleselectChange(value, key, status(t))
                                }
                            />
                        ),
                    };
                    break;
                case 'Activity':
                    filter[3] = {
                        key: 'Activity',
                        label: t('Activity'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    Activity(t).filter((value) => {
                                        return (
                                            value.value ==
                                            allFiltersNew[key].textValue
                                        );
                                    })[0]?.['value']
                                }
                                options={Activity(t)}
                                onChange={(value) =>
                                    handleselectChange(value, key, Activity(t))
                                }
                            />
                        ),
                    };
                    break;
                case 'Barcode Exists':
                    filter[4] = {
                        key: 'Barcode Exists',
                        label: t('Barcode Exists'),
                        filter: (
                            <PolarisSelect
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    barcodeExist.filter((value) => {
                                        return (
                                            value.value ==
                                            allFiltersNew[key].textValue
                                        );
                                    })?.[0]?.['value']
                                }
                                options={barcodeExist}
                                onChange={(value) =>
                                    handleselectChange(
                                        value,
                                        'Barcode Exists',
                                        barcodeExist
                                    )
                                }
                            />
                        ),
                    };
                    break;
                // case 'variant_title':
                //     filter[5] = {
                //         key: 'variant_title',
                //         label: t('Title'),
                //         filter: (
                //             <BlockStack gap="200">
                //                 <PolarisSelect
                //                     label=""
                //                     placeholder=""
                //                     options={optionsSKUSelect(t)}
                //                     value={t(tempData[key]['selectValue'])}
                //                     onChange={(value) => {

                //                         tempData[key]['selectValue'] = value;
                //                         if (tempData[key]['textValue'] !== '')
                //                             props.di.globalState.removeLocalStorage(
                //                                 'paginationVariant'
                //                             );
                //                         props.di.globalState.set(
                //                             'filtersVariants',
                //                             JSON.stringify(tempData),
                //                             true
                //                         );
                //                         setallFilters({ ...tempData });
                //                     }}
                //                 />
                //                 <TextField
                //                     labelHidden
                //                     autoComplete="off"
                //                     label={undefined}
                //                     placeholder={t("enter value")}
                //                     value={tempData[key]['textValue']}
                //                     onChange={(value) => {
                //                         tempData[key]['textValue'] =
                //                             value.trim() != '' ? value : '';
                //                         tempData[key]['change'] =
                //                             value.trim() != '' ? true : false;
                //                         props.di.globalState.removeLocalStorage(
                //                             'paginationVariant'
                //                         );
                //                         props.di.globalState.set(
                //                             'filtersVariants',
                //                             JSON.stringify(tempData),
                //                             true
                //                         );
                //                         setallFilters({ ...tempData });
                //                     }}
                //                 />
                //             </BlockStack>
                //         ),
                //     };
                //     break;
            }
        });
        setfilter(filter);
    }, [allFiltersNew]);

    const handleFiltersQueryChange = useCallback(
        (value: any, keyFilter: boolean | string = false) => {
            let temp = { ...allFiltersNew };
            Object.keys(allFiltersNew).forEach((key) => {
                if (keyFilter && key == 'variant query') {
                    setQueryValue(value)
                    temp[key]['textValue'] = value;
                    temp[key]['change'] = true;

                }
                else if (value == key) {
                    temp[key]['textValue'] = '';
                    temp[key]['change'] = false;
                }

            });
            setallFilters(temp);
            props.di.globalState.set(
                'filtersVariants',
                JSON.stringify(temp),
                true
            );
        },
        [allFiltersNew]
    );



    useEffect(() => {
        let temp: any = [...appliedFilters];
        let allFiltersNewTems = JSON.parse(props.di.globalState.get("filtersVariants", true) || "{}") || allFiltersNew
        Object.keys(allFiltersNewTems).forEach((key) => {
            if (allFiltersNewTems[key].change) {
                // console.log(key, "xcfvgbhn");

                if (key == 'Inventory') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems[key]['textValue'])}`,
                        onRemove: handleFiltersQueryChange,
                    };
                } else if (key === 'Activity') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(Activity(t).filter(
                                (value) =>
                                    value.value ==
                                    allFiltersNewTems[key]['textValue']
                            )?.[0]?.['label']
                            )}`,
                        onRemove: handleFiltersQueryChange,
                    };
                } else if (key === 'Container_id') {
                    temp[key] = {
                        key: key,
                        label: `${allFiltersNewTems[key]?.type} Contains ${allFiltersNewTems?.[key]?.['searchvalue']}`,
                        onRemove: handleFiltersQueryChange,
                    };
                } else if (key === 'Template name') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems?.[key]?.['label'])}`,
                        onRemove: handleFiltersQueryChange,
                    };
                } else if (key === 'Error') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems?.[key]?.['errorName'])}`,
                        onRemove: handleFiltersQueryChange,
                    };
                } else if (key === 'Barcode Exists') {
                    temp[key] = {
                        key: key,
                        label: `${t("Barcode Exists")} ${allFiltersNewTems?.[key]?.['textValue'] == '1'
                            ? t('True')
                            : t('False')
                            }`,
                        onRemove: handleFiltersQueryChange,
                    };
                }
                else if (key === 'variant query') {
                    temp[key] = {
                        key: key,
                        label: `${t("SKU contains")} ${allFiltersNewTems?.[key]?.['textValue']}`,
                        onRemove: handleFiltersQueryChange,
                    };
                } else {
                    temp[key] = {
                        key: key,
                        label: `${t(key)}
                        ${optionsSKUSelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            }
                            ${t(allFiltersNewTems?.[key]?.['textValue'])}`,
                        onRemove: handleFiltersQueryChange,
                    };
                }
            } else delete temp[key];
        });
        setAppliedFilters(temp);
    }, [props.di.globalState.get("filtersVariants", true), allFiltersNew]);

    if (!isEmpty(sku)) {
        const key = 'sku';
        appliedFilters.push({
            key,
            label: `sku is ${sku}`,
            onRemove: handleSku,
        });
    }


    const handleClearAllFilters = useCallback(() => {
        let tempData = { ...allFiltersNew };
        Object.keys(tempData).forEach((key) => {
            if (tempData[key].change) {
                tempData[key].textValue = '';
                tempData[key].change = false;
            }
        });
        setallFilters(tempData);
        props.di.globalState.removeLocalStorage('filtersVariants');
        setAppliedFilters([]);
    }, []);

    return (
        <Filters
            queryValue={allFiltersNew['variant query']?.textValue}
            queryPlaceholder={t("Search items by SKU")}
            filters={filter}
            disabled={loading}
            appliedFilters={Object.values(appliedFilters)}
            onQueryChange={(value) => handleFiltersQueryChange(value, "query")}
            onQueryClear={() => handleFiltersQueryChange("", 'query')}
            onClearAll={handleClearAllFilters}>
            {/* <Popover
                active={popoverActive}
                fullHeight
                activator={
                    <Button
                        variant="secondary"
                        icon={SortMinor}
                        onClick={() => setPopoverActive(!popoverActive)}
                    />
                }
                preferredAlignment="right"
                onClose={() => setPopoverActive(false)}>
                <Popover.Pane height={sortValue === '' ? '150px' : ''}>
                    <Box paddingInlineStart={"100"} paddingInlineEnd={"400"}>
                        <Popover.Section>
                            <BlockStack gap={'100'}>
                                <Text as="p" variant="bodyMd" tone="subdued">
                                    Sort
                                </Text>

                                <BlockStack gap={'300'}>
                                    <BlockStack gap={'0'}>
                                        <RadioButton
                                            label="By Date"
                                            id="byDate"
                                            checked={sortValue === 'byDate'}
                                            name="sortVariant"
                                            onChange={(e, id) => handleChange(id)}
                                        />
                                        {sortValue === 'byDate' && (
                                            <div className="custom-variant-sort__item">
                                                <ActionList
                                                    allowFiltering
                                                    actionRole="menuitem"
                                                    items={[
                                                        { content: 'Oldest first' },
                                                        { content: 'Newest first' },
                                                    ]}
                                                />
                                            </div>
                                        )}
                                    </BlockStack>
                                    <BlockStack gap={'0'}>
                                        <RadioButton
                                            label="By Title"
                                            name="sortVariant"
                                            id="byTitle"
                                            checked={sortValue === 'byTitle'}
                                            onChange={(e, id) => handleChange(id)}
                                        />
                                        {sortValue === 'byTitle' && (
                                            <div className="custom-variant-sort__item">
                                                <ActionList
                                                    actionRole="menuitem"
                                                    items={[
                                                        { content: 'A-Z' },
                                                        { content: 'Z-A' },
                                                    ]}
                                                />
                                            </div>
                                        )}
                                    </BlockStack>
                                    <BlockStack gap={'0'}>
                                        <RadioButton
                                            label="By Variants"
                                            name="sortVariant"
                                            id="byVariants"
                                            checked={sortValue === 'byVariants'}
                                            onChange={(e, id) => handleChange(id)}
                                        />
                                        {sortValue === 'byVariants' && (
                                            <div className="custom-variant-sort__item">
                                                <ActionList
                                                    actionRole="menuitem"
                                                    items={[
                                                        { content: 'Colour' },
                                                        { content: 'Size' },
                                                        { content: 'Fabric' },
                                                    ]}
                                                />
                                            </div>
                                        )}
                                    </BlockStack>
                                </BlockStack>
                            </BlockStack>
                        </Popover.Section>
                    </Box>
                </Popover.Pane>
            </Popover> */}
        </Filters>
    );

    function isEmpty(value: string | string[]): boolean {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else {
            return value === '' || value == null;
        }
    }
}

export default DI(VariantGridFilter);